export default __webpack_public_path__ + "media/newsletter-bg-girl.c26e8b54.png";